<template>
  <v-flex xs12 sm6 d-flex>
    <v-select
      :items="operations"
      label="Operação"
      v-model="operation"
      item-text="title"
      item-value="business"
      return-object
    ></v-select>
  </v-flex>
</template>
<script>
import { mapGetters } from "vuex";
import * as business from "@/helpers/business";

export default {
  name: "Operation",
  computed: {
    operation: {
      get() {
        return this.model;
      },
      set(value) {
        this.$store.dispatch("partners_payments/setOperation", value);
        this.model;
      },
    },
    ...mapGetters({
      model: "partners_payments/filtersOperation",
    }),
  },
  data: () => ({
    operations: [
      { title: "Crédito", business: business.OPERATION_CREDIT },
      { title: "Débito", business: business.OPERATION_DEBIT },
    ],
  }),
};
</script>
